export default {
    "01-15": {
        year: 1759,
        title: "KÜLTÜR VE TARİH GÜNÜ",
        text: "1759'da British Museum halka açıldı, 2001'de Vikipedi yayın hayatına başladı ve 1902'de Nâzım Hikmet doğdu.",
        questions: [
            {
                text: "British Museum kaç yılında halka açılmıştır?",
                options: ["1859", "1759", "1901", "1650"],
                correct: 1
            },
            {
                text: "2001 yılında yayın hayatına başlayan internet ansiklopedisi hangisidir?",
                options: ["Google", "Ekşi Sözlük", "Vikipedi", "Yahoo"],
                correct: 2
            },
            {
                text: "15 Ocak 1902'de doğan ünlü Türk şair kimdir?",
                options: ["Nâzım Hikmet", "Orhan Veli", "Attila İlhan", "Cemal Süreya"],
                correct: 0
            }
        ]
    },
    "01-16": {
        year: 1923,
        title: "BASIN ONUR GÜNÜ",
        text: "1923'te Mustafa Kemal Paşa İzmit'te ilk basın toplantısını düzenledi. 1979'da İran Şahı Rıza Pehlevi ülkesini terk etti.",
        questions: [
            {
                text: "Mustafa Kemal Paşa'nın 1923'te ilk basın toplantısını yaptığı şehir hangisidir?",
                options: ["Ankara", "İstanbul", "İzmir", "İzmit"],
                correct: 3
            },
            {
                text: "1979 yılında ülkesini terk eden İran lideri kimdir?",
                options: ["Humeyni", "Rıza Pehlevi", "Musaddık", "Ahmedinejad"],
                correct: 1
            },
            {
                text: "Basın Onur Günü hangi tarihle ilişkilidir?",
                options: ["16 Ocak 1923", "23 Nisan 1920", "29 Ekim 1923", "19 Mayıs 1919"],
                correct: 0
            }
        ]
    },
    "01-17": {
        year: 1991,
        title: "ÇÖL FIRTINASI VE TÜNEL",
        text: "1991'de Körfez Savaşı'nda 'Çöl Fırtınası' harekatı başladı. 1875'te dünyanın en eski ikinci metrosu olan Tünel açıldı.",
        questions: [
            {
                text: "1991'de Irak'a karşı başlatılan harekatın adı nedir?",
                options: ["Kararlı Güç", "Çöl Fırtınası", "Şok ve Dehşet", "Zeytin Dalı"],
                correct: 1
            },
            {
                text: "Karaköy-Beyoğlu Tüneli kaç yılında hizmete açılmıştır?",
                options: ["1900", "1850", "1875", "1923"],
                correct: 2
            },
            {
                text: "Çöl Fırtınası harekatı hangi ülkeye karşı yapılmıştır?",
                options: ["İran", "Afganistan", "Suriye", "Irak"],
                correct: 3
            }
        ]
    },
    "01-18": {
        year: 1919,
        title: "PARİS BARIŞ KONFERANSI",
        text: "1919'da I. Dünya Savaşı'nı sona erdiren barış antlaşmalarının görüşüldüğü Paris Barış Konferansı başladı.",
        questions: [
            {
                text: "1919'da toplanan ve I. Dünya Savaşı'nın sonuçlarının görüşüldüğü konferans hangisidir?",
                options: ["Viyana Kongresi", "Berlin Konferansı", "Paris Barış Konferansı", "Yalta Konferansı"],
                correct: 2
            },
            {
                text: "Paris Barış Konferansı'nın temel amacı neydi?",
                options: ["II. Dünya Savaşı'nı başlatmak", "Barış antlaşmalarını hazırlamak", "NATO'yu kurmak", "Sömürgeciliği kaldırmak"],
                correct: 1
            },
            {
                text: "Paris Barış Konferansı hangi savaşın ardından toplanmıştır?",
                options: ["I. Dünya Savaşı", "II. Dünya Savaşı", "Soğuk Savaş", "Kırım Savaşı"],
                correct: 0
            }
        ]
    },
    "01-19": {
        year: 2007,
        title: "HRANT DİNK VE RADYO",
        text: "2007'de gazeteci Hrant Dink hayatını kaybetti. 1903'te ABD ile İngiltere arasında ilk okyanus aşırı radyo yayını yapıldı.",
        questions: [
            {
                text: "1903 yılında ilk okyanus aşırı radyo yayını hangi iki ülke arasında yapılmıştır?",
                options: ["ABD - Fransa", "ABD - İngiltere", "Almanya - Japonya", "Rusya - Çin"],
                correct: 1
            },
            {
                text: "19 Ocak 2007'de suikasta kurban giden gazeteci kimdir?",
                options: ["Uğur Mumcu", "Abdi İpekçi", "Hrant Dink", "Çetin Emeç"],
                correct: 2
            },
            {
                text: "Atlantik üzerinden ilk radyo mesajı hangi yıl gönderilmiştir?",
                options: ["1890", "1903", "1923", "1950"],
                correct: 1
            }
        ]
    },
    "01-20": {
        year: 1921,
        title: "İLK ANAYASA",
        text: "1921'de TBMM Teşkilat-ı Esasiye Kanunu'nu kabul etti. 2009'da Barack Obama ABD'nin ilk siyah başkanı oldu.",
        questions: [
            {
                text: "Yeni Türk Devleti'nin 1921'de kabul edilen ilk anayasasının adı nedir?",
                options: ["Kanun-i Esasi", "1924 Anayasası", "Teşkilat-ı Esasiye", "Tanzimat Fermanı"],
                correct: 2
            },
            {
                text: "ABD'nin ilk siyah başkanı kimdir?",
                options: ["Martin Luther King", "Malcolm X", "Barack Obama", "George Bush"],
                correct: 2
            },
            {
                text: "Teşkilat-ı Esasiye Kanunu hangi savaş devam ederken kabul edilmiştir?",
                options: ["I. Dünya Savaşı", "Kurtuluş Savaşı", "Balkan Savaşları", "Trablusgarp Savaşı"],
                correct: 1
            }
        ]
    },
    "01-21": {
        year: 1925,
        title: "LENİN VE OSMANLI",
        text: "1925'te SSCB kurucusu Lenin öldü. 1774'te Osmanlı Padişahı III. Mustafa vefat etti, I. Abdülhamid tahta çıktı.",
        questions: [
            {
                text: "1774 yılında tahta çıkan Osmanlı padişahı kimdir?",
                options: ["III. Selim", "I. Abdülhamid", "II. Mahmud", "IV. Murad"],
                correct: 1
            },
            {
                text: "21 Ocak 1925'te ölen Sovyetler Birliği'nin kurucusu lider kimdir?",
                options: ["Stalin", "Troçki", "Lenin", "Gorbaçov"],
                correct: 2
            },
            {
                text: "1774'te vefat eden Osmanlı Padişahı kimdir?",
                options: ["III. Mustafa", "I. Süleyman", "II. Ahmed", "I. İbrahim"],
                correct: 0
            }
        ]
    },
    "01-22": {
        year: 1517,
        title: "RİDANİYE ZAFERİ",
        text: "1517'de Yavuz Sultan Selim Ridaniye Savaşı'nı kazandı, Mısır fethedildi. 1905'te Rusya'da 'Kanlı Pazar' yaşandı.",
        questions: [
            {
                text: "Ridaniye Savaşı'nda Osmanlı ordusunun karşısındaki Memlûk hükümdarı kimdir?",
                options: ["Kansu Gavri", "Tomanbay", "Aybek", "Kutuz"],
                correct: 1
            },
            {
                text: "1905 Rus Devrimi'nin başlamasına neden olan 'Kanlı Pazar' olayına liderlik eden papaz kimdir?",
                options: ["Grigori Rasputin", "Lev Troçki", "Georgi Gapon", "Aleksandr Kerenski"],
                correct: 2
            },
            {
                text: "Ridaniye Zaferi sonucunda Osmanlı Devleti'nin eline geçen 'Kutsal Emanetler' ilk nerede muhafaza edilmiştir?",
                options: ["Hırka-i Saadet Dairesi", "Revan Köşkü", "Arz Odası", "Bağdat Köşkü"],
                correct: 0
            }
        ]
    },
    "01-23": {
        year: 1913,
        title: "BÂB-I ÂLİ BASKINI",
        text: "1913'te İttihatçılar Bâb-ı Âli Baskını ile hükümeti devirdi. 1793'te Polonya ikinci kez paylaşıldı.",
        questions: [
            {
                text: "Bâb-ı Âli Baskını sonucunda istifa ettirilen sadrazam kimdir?",
                options: ["Sait Halim Paşa", "Talat Paşa", "Kamil Paşa", "Hüseyin Hilmi Paşa"],
                correct: 2
            },
            {
                text: "Bâb-ı Âli Baskını'nın fiili lideri kimdir?",
                options: ["Enver Bey", "Cemal Paşa", "Resneli Niyazi", "Yakup Cemil"],
                correct: 0
            },
            {
                text: "Polonya'nın paylaşılmasını protesto eden ve toprak bütünlüğünü savunan tek devlet hangisidir?",
                options: ["Avusturya", "Fransa", "Osmanlı Devleti", "İngiltere"],
                correct: 2
            }
        ]
    },
    "01-24": {
        year: 1993,
        title: "UĞUR MUMCU VE 24 OCAK",
        text: "1993'te Uğur Mumcu suikasta uğradı. 1980'de Türk ekonomisini değiştiren '24 Ocak Kararları' açıklandı.",
        questions: [
            {
                text: "24 Ocak 1980 Kararları'nın mimarı kimdir?",
                options: ["Adnan Kahveci", "Turgut Özal", "Mesut Yılmaz", "Süleyman Demirel"],
                correct: 1
            },
            {
                text: "Roma İmparatorluğu'nun 395'te ikiye ayrılmasıyla Doğu Roma tahtına kim geçmiştir?",
                options: ["Honorius", "Arcadius", "Jüstinyen", "Konstantin"],
                correct: 1
            },
            {
                text: "24 Ocak Kararları ile hangisine son verilmiştir?",
                options: ["İthal ikameci sanayileşme", "İhracata dayalı büyüme", "Serbest kur rejimi", "Yabancı sermaye teşviki"],
                correct: 0
            }
        ]
    },
    "01-25": {
        year: 1072,
        title: "DÎVÂNU LUGÂTİ'T-TÜRK",
        text: "1072'de Kaşgarlı Mahmud Dîvânu Lugâti't-Türk'ü yazmaya başladı. 1924'te ilk Kış Olimpiyatları yapıldı.",
        questions: [
            {
                text: "Kaşgarlı Mahmud, eserini hangi Abbasi Halifesine sunmuştur?",
                options: ["El-Muktedî Biemrillah", "Harun Reşid", "El-Me'mun", "El-Mutasım"],
                correct: 0
            },
            {
                text: "Dîvânu Lugâti't-Türk'ün tek yazma nüshası hangi kütüphanededir?",
                options: ["Süleymaniye", "Millet Kütüphanesi", "Topkapı Sarayı", "Beyazıt Devlet"],
                correct: 1
            },
            {
                text: "İlk Kış Olimpiyatları 1924 yılında nerede düzenlenmiştir?",
                options: ["İsviçre", "Norveç", "Fransa (Chamonix)", "Kanada"],
                correct: 2
            }
        ]
    },
    "01-26": {
        year: 1699,
        title: "KARLOFÇA ANTLAŞMASI",
        text: "1699'da Osmanlı Karlofça Antlaşması'nı imzaladı, Gerileme Dönemi başladı. 1926'da Televizyon icat edildi.",
        questions: [
            {
                text: "Karlofça Antlaşması'nda arabuluculuk yapan devletler hangileridir?",
                options: ["Fransa - İsveç", "İngiltere - Hollanda", "Rusya - Prusya", "Almanya - İtalya"],
                correct: 1
            },
            {
                text: "Karlofça'ya imza atmayıp 1700 İstanbul Antlaşması'nı imzalayan devlet hangisidir?",
                options: ["Venedik", "Lehistan", "Rusya", "Avusturya"],
                correct: 2
            },
            {
                text: "Karlofça Antlaşması ile Mora ve Dalmaçya kime bırakılmıştır?",
                options: ["Avusturya", "Lehistan", "Venedik", "Malta"],
                correct: 2
            }
        ]
    },
    "01-27": {
        year: 1945,
        title: "GURGEN YANİKYAN VE AUSCHWİTZ",
        text: "1945'te Auschwitz kampı kurtarıldı. 1973'te Türk diplomatlar Los Angeles'ta şehit edildi.",
        questions: [
            {
                text: "Halil İnalcık'a göre Osmanlı Devleti'nin gerçek kuruluş tarihi olan 1302 savaşının adı nedir?",
                options: ["Maltepe", "Koyunhisar (Bafeus)", "Çirmen", "Sazlıdere"],
                correct: 1
            },
            {
                text: "1973'te Türk diplomatlarını şehit eden terörist Gurgen Yanikyan'ın mesleği neydi?",
                options: ["Doktor", "Mühendis", "Yazar", "Avukat"],
                correct: 2
            },
            {
                text: "Auschwitz'in kurtarılması günümüzde hangi anma günü olarak kabul edilir?",
                options: ["Dünya Barış Günü", "İnsan Hakları Günü", "Holokostu Anma Günü", "Irkçılıkla Mücadele Günü"],
                correct: 2
            }
        ]
    },
    "01-28": {
        year: 1920,
        title: "MİSAK-I MİLLİ VE CHALLENGER",
        text: "1920'de Misak-ı Milli kabul edildi. 1986'da Challenger uzay mekiği düştü.",
        questions: [
            {
                text: "Misak-ı Milli'de halk oylaması öngörülen bölgelerden hangisi yoktur?",
                options: ["Elviye-i Selase", "Batı Trakya", "Arap toprakları", "Doğu Trakya"],
                correct: 3
            },
            {
                text: "Misak-ı Milli kararlarını kabul eden grubun adı nedir?",
                options: ["Müdafaa-i Hukuk", "Felah-ı Vatan", "Tesanüd", "Islahat"],
                correct: 1
            },
            {
                text: "Challenger kazasında ölen 'Uzaydaki İlk Öğretmen' kimdir?",
                options: ["Sally Ride", "Christa McAuliffe", "Judith Resnik", "Valentina Tereşkova"],
                correct: 1
            }
        ]
    },
    "01-29": {
        year: 1923,
        title: "MUSTAFA KEMAL PAŞA'NIN EVLİLİĞİ",
        text: "1923'te Mustafa Kemal Paşa ile Latife Hanım evlendi. 1948'de Kâzım Karabekir hayatını kaybetti.",
        questions: [
            {
                text: "Mustafa Kemal Paşa ile Latife Hanım'ın nikahını kıyan dönemin İzmir Müftüsü kimdir?",
                options: ["Rıfat Börekçi", "Rahmetullah Efendi", "Mehmet Rifat Efendi", "Hoca Raif Efendi"],
                correct: 1
            },
            {
                text: "Kâzım Karabekir Paşa Milli Mücadele'de hangi cephenin komutanıydı?",
                options: ["15. Kolordu (Doğu Cephesi)", "1. Ordu (Batı Cephesi)", "5. Süvari Kolordusu", "El-Cezire Komutanlığı"],
                correct: 0
            },
            {
                text: "III. Mehmed'in tahta çıkar çıkmaz uyguladığı ve rekor olan olay nedir?",
                options: ["Kafes usulünü getirmesi", "19 kardeşini boğdurması", "Celali isyanlarını başlatması", "Sigara yasağı getirmesi"],
                correct: 1
            }
        ]
    },
    "01-30": {
        year: 1923,
        title: "NÜFUS MÜBADELESİ",
        text: "1923'te Türkiye-Yunanistan Nüfus Mübadelesi Sözleşmesi imzalandı. 1948'de Mahatma Gandhi öldürüldü.",
        questions: [
            {
                text: "Nüfus Mübadelesi'nde 'yerleşik' (etabli) sayılarak mübadele dışı tutulan Türk nüfus neresidir?",
                options: ["Selanik ve çevresi", "Girit Adası", "Batı Trakya", "Mora Yarımadası"],
                correct: 2
            },
            {
                text: "Mübadele Komisyonu'nun merkezi hangi şehirdi?",
                options: ["Cenevre", "Atina", "İstanbul", "Ankara"],
                correct: 2
            },
            {
                text: "Gandhi'nin sivil itaatsizlik eylemine verilen felsefi ad nedir?",
                options: ["Nirvana", "Satyagraha", "Dharma", "Karma"],
                correct: 1
            }
        ]
    },
    "01-31": {
        year: 1990,
        title: "MUAMMER AKSOY VE TED",
        text: "1990'da Muammer Aksoy suikasta uğradı. 1928'de Türk Eğitim Derneği (TED) kuruldu.",
        questions: [
            {
                text: "1961 Anayasası hangi askeri müdahale sonrasında hazırlanmıştır?",
                options: ["12 Mart 1971", "12 Eylül 1980", "27 Mayıs 1960", "28 Şubat 1997"],
                correct: 2
            },
            {
                text: "Aşağıdakilerden hangisi Wilson İlkeleri'nden biri değildir?",
                options: ["Galip devletler toprak almayacak", "Diplomaside açıklık olacak", "Savaş tazminatı alınacak", "Self-determinasyon"],
                correct: 2
            },
            {
                text: "Türk Eğitim Derneği (TED) ilk yıllarda hangi isimle faaliyet göstermiştir?",
                options: ["Türk Maarif Cemiyeti", "Millet Mektepleri", "Halkevleri", "Darülmuallimin"],
                correct: 0
            }
        ]
    }
};
